var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGlutenFree(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.25 12C1.25 6.06294 6.06294 1.25 12 1.25C14.9683 1.25 17.6569 2.45406 19.6014 4.3986C21.5459 6.34315 22.75 9.03168 22.75 12C22.75 17.9371 17.9371 22.75 12 22.75C9.03168 22.75 6.34315 21.5459 4.3986 19.6014C2.45406 17.6569 1.25 14.9683 1.25 12ZM12 2.75C6.89137 2.75 2.75 6.89137 2.75 12C2.75 14.2846 3.57746 16.3748 4.95032 17.989L17.989 4.95032C16.3748 3.57746 14.2846 2.75 12 2.75ZM19.0497 6.01098L6.01098 19.0497C7.62517 20.4225 9.71538 21.25 12 21.25C17.1086 21.25 21.25 17.1086 21.25 12C21.25 9.71538 20.4225 7.62517 19.0497 6.01098Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.3327 16.8493C10.6392 16.9204 10.9582 16.9579 11.2857 16.9579H11.375V20.3618C11.375 20.7143 11.6548 21 12 21C12.3452 21 12.625 20.7143 12.625 20.3618V16.9579H12.7143C15.0812 16.9579 17 14.9985 17 12.5815C17 12.1786 16.6802 11.8521 16.2857 11.8521C15.9048 11.8521 15.5355 11.9028 15.184 11.998L10.3327 16.8493Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.6837 7.13433C13.9415 5.75781 13.5486 4.2793 12.505 3.21364C12.2261 2.92879 11.7738 2.92879 11.4949 3.21364C9.86217 4.8809 9.82221 7.55872 11.375 9.27546V9.44302L13.6837 7.13433Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.2773 9.5407C10.5083 8.3687 9.19954 7.59717 7.71429 7.59717C7.3198 7.59717 7 7.92374 7 8.32658C7 9.83014 7.74251 11.1566 8.87352 11.9445L11.2773 9.5407Z",
    fill: "currentColor"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M8.81915 11.9989C8.46666 11.9031 8.09631 11.8521 7.71429 11.8521C7.3198 11.8521 7 12.1786 7 12.5815C7 12.9614 7.04741 13.33 7.13652 13.6815L8.81915 11.9989Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGlutenFree);
export default __webpack_public_path__ + "static/media/gluten-free.d15703a4bf2b91711fe2c45ac7277f6c.svg";
export { ForwardRef as ReactComponent };